// Comparación de nombres escritos a mano: detecta el mismo nombre con otras
// mayúsculas, tildes, espacios o un error de digitación ("Carlos" / "Calos").

// "  José   PÉREZ " -> "jose perez"
export const normalizarTexto = (texto = "") =>
  texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

// "  Carlos   Pérez " -> "Carlos Pérez" (conserva mayúsculas y tildes)
export const limpiarEspacios = (texto = "") => texto.replace(/\s+/g, " ").trim();

// cantidad mínima de letras a cambiar para pasar de un texto al otro (Levenshtein)
const distanciaEdicion = (a, b) => {
  let anterior = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i += 1) {
    const actual = [i];
    for (let j = 1; j <= b.length; j += 1) {
      const costo = a[i - 1] === b[j - 1] ? 0 : 1;
      actual[j] = Math.min(anterior[j] + 1, actual[j - 1] + 1, anterior[j - 1] + costo);
    }
    anterior = actual;
  }
  return anterior[b.length];
};

// errores tolerados según el largo: nombres cortos 1 letra, largos hasta 2
const erroresPermitidos = (largo) => (largo <= 4 ? 1 : 2);

// Busca en `existentes` el texto igual o más parecido a `nuevo`.
// -> { tipo: "igual" | "parecido", valor } o null si no hay ninguno cercano
export const buscarParecido = (nuevo, existentes = []) => {
  const buscado = normalizarTexto(nuevo);
  if (!buscado) return null;

  let mejor = null;
  existentes.forEach((existente) => {
    const candidato = normalizarTexto(existente);
    if (candidato === buscado) {
      mejor = { tipo: "igual", valor: existente, distancia: 0 };
      return;
    }
    if (mejor?.tipo === "igual") return;
    const distancia = distanciaEdicion(buscado, candidato);
    const permitido = erroresPermitidos(Math.min(buscado.length, candidato.length));
    if (distancia <= permitido && (!mejor || distancia < mejor.distancia)) {
      mejor = { tipo: "parecido", valor: existente, distancia };
    }
  });

  return mejor && { tipo: mejor.tipo, valor: mejor.valor };
};
